import { Box } from "@mui/material";
import styled from "styled-components";

export const Wrapper = styled(Box)`
  position: relative;
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    height: auto;
    max-height: 100%;
  }

  & footer a:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primary.white};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const WESRContainer = styled(Box)`
  /* expose heights as CSS vars */
  --app-h: ${({ theme }) => theme.appNav.height};
  --ftr-h: ${({ theme }) => theme.footerNav.height};

  display: flex;
  flex-direction: column;
  width: 100%;
  /* fixed viewport height at ALL widths */
  height: calc(100dvh - (var(--app-h) + var(--ftr-h)));
  min-height: 0; /* critical for nested scroll areas */

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    /* allow page to grow and scroll if content needs more space */
    height: auto;
    min-height: calc(100dvh - (var(--app-h) + var(--hdr-h) + var(--ftr-h)));
  }
`;
